































































































/*
  sendMessageTeacherInfoManage, sendMessagePropositionTeacherEmploy 发送短信息
  sendNoticeTeacherInfoManage 发送通知
*/
import { Vue, Component, Prop } from "vue-property-decorator";
import { Tree as ElTree } from "element-ui";
//引入教师信息管理中的接口
import {
  sendMessageTeacherInfoManage,
  sendNoticeTeacherInfoManage,
  getMsgTeacher
} from "../../../../api/teacherInfoManage";
//引入命题教师聘用的接口
import { sendMessagePropositionTeacherEmploy } from "../../../../api/propositionTeacherEmploy";

@Component({
  name: "teacherInfoManageDetail"
})
export default class extends Vue {
  @Prop(Array) projects!: object[]; //项目列表
  @Prop(String) defaultProjectId!: string; //默认项目ID
  @Prop({ type: Number, default: null }) defaultIsBlacklist!: number | null; //默认黑名单筛选
  @Prop(String) fromPage!: string; //父组件页面
  @Prop(String) msgType!: string; //发送短信息 or 发送通知

  private checkAll: boolean = false;
  private defaultProps: object = {
    children: "nodes",
    label: "name"
  };
  private dialogFormTitle: string = ""; //弹窗标题
  private msg: string = ""; //短信内容
  private choosedTeacherIds: string[] = []; //选中的教师id
  private localProjectId: string = ""; //弹窗内项目筛选
  private localIsBlacklist: number | null = null; //弹窗内黑名单筛选
  private loading: boolean = false; //加载状态
  private treeVos: object = {}; //教师树数据

  created() {
    this.dialogFormTitle = this.msgType === "msg" ? "发送短信息" : "发送通知";
    this.localProjectId = this.defaultProjectId || "";
    this.localIsBlacklist = this.defaultIsBlacklist;
    this.loadTeacherTree();
  }

  //将获取到的treeVos整理成渲染需要的格式
  get treeData() {
    return [this.treeVos];
  }

  //点击"全选/取消全选"的处理
  private checkAllHandle(v: boolean) {
    if (v) {
      (this.$refs.mailListTree as ElTree).setCheckedNodes(this.treeData);
    } else {
      (this.$refs.mailListTree as ElTree).setCheckedNodes([]);
    }
  }

  //点击复选框，判断是否全选
  private checkHandle(current, checkedObj) {
    //选中的key个数
    let checkedLength = checkedObj.checkedKeys.length;
    //tree的总key数
    let totalLength = (this.$refs.mailListTree as any).treeItems.length;
    //个数相等，代表全选
    checkedLength === totalLength
      ? (this.checkAll = true)
      : (this.checkAll = false);
  }

  //节点选中状态发生变化时
  private checkChange(current, status) {
    //current 是当前节点对象  status是当前节点是否选中
    //如果没有nodes，说明是教师节点
    if (!current.nodes) {
      if (status) {
        //被选中
        this.choosedTeacherIds.push(current.id);
      } else {
        //不选中
        this.choosedTeacherIds.forEach((i, index) => {
          if (i === current.id) {
            this.choosedTeacherIds.splice(index, 1);
          }
        });
      }
    }
  }

  //加载教师树数据
  private async loadTeacherTree() {
    this.loading = true;
    try {
      const params: any = {};
      if (this.localProjectId) {
        params.projectId = this.localProjectId;
      }
      if (this.localIsBlacklist !== null) {
        params.teacherIsBlacklist = this.localIsBlacklist;
      }
      const res = await getMsgTeacher(params);
      this.treeVos = res.data || {};
      //重置选中状态
      this.checkAll = false;
      this.choosedTeacherIds = [];
      this.$nextTick(() => {
        if (this.$refs.mailListTree) {
          (this.$refs.mailListTree as ElTree).setCheckedNodes([]);
        }
      });
    } catch (error) {
      this.$message.error("加载教师列表失败");
    } finally {
      this.loading = false;
    }
  }

  //点击"发送"的处理
  private async sendHandle() {
    if (this.choosedTeacherIds.length <= 0) {
      this.$message.warning("请先勾选！");
      return false;
    }
    if (!this.msg) {
      this.$message.warning("请输入内容！");
      return false;
    }
    let params = {
      ids: this.choosedTeacherIds,
      msg: this.msg
    };

    const loading = this.$loading({
      lock: true,
      text: '发送中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    try {
      if (this.fromPage === "teacherInfoManage") {
        //教师信息管理页面
        if (this.msgType === "msg") {
          //发送短信息
          await sendMessageTeacherInfoManage(params);
        } else {
          //发送通知
          await sendNoticeTeacherInfoManage(params);
        }
      } else if (this.fromPage === "propositionTeacherEmploy") {
        //命题教师聘用页面
        if (this.msgType === "msg") {
          //发送短信息
          await sendMessagePropositionTeacherEmploy(params);
        }
      }
      this.$message.success("发送成功");
      //关闭弹窗
      (this.$parent as any).showSendMessage = false;
      //操作成功，重新获取列表
      (this.$parent as any).getData();
    } catch (error) {
      // this.$message.error(error || "发送失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    } finally {
      loading.close();
    }
  }
}
